import { Box } from "@mui/material";
import CustomizedTables from "../../common/Table";
import { getViews, removeView } from "../Properties/Properties.service";
import { useCountryParam } from "../../common/util/useCountryParam";

const ArrangeView = () => {
    const country = useCountryParam();
    const columns = [
        { key: "firstname", label: "First Name", minWidth: 150 },
        { key: "lastname", label: "Last Name", minWidth: 150 },
        { key: "email", label: "Email", minWidth: 200 },
        { key: "number", label: "Contact Number", minWidth: 150 },
        { key: "latestNews", label: "Get News", minWidth: 130 },
        { key: "createAccount", label: "Create Account", minWidth: 220 },
        { key: "terms", label: "Terms & Conditions", minWidth: 220 },

    ];

    return (
        <>
            <Box sx={{ paddingY: 6, width: "100%" }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <h2>Arrange View List ({country.toUpperCase()})</h2>
                </Box>

                <CustomizedTables
                    columns={columns}
                    listService={() => getViews(country)}
                    deleteService={removeView}
                    isUser={true}
                />
            </Box>
        </>
    );
};

export default ArrangeView;
